export enum Units {
  METRIC = 'metric',
  IMPERIAL = 'imperial',
  MARITIME = 'maritime', // Changed from NAUTICAL to MARITIME
}

// Legacy enum for backwards compatibility
export enum MeasureToolUnits {
  KILOMETERS = 'kilometers',
  NAUTICAL_MILES = 'nautical_miles',
}
